import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRepublishDto } from '@coin/importer/dto/util';
import { switchMap, tap } from 'rxjs/operators';
import { RepublishService } from '../../services/republish/republish.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SubHeaderComponent } from '../../components/sub-header/sub-header.component';
import { ButtonFooterComponent } from '../../components/button-footer/button-footer.component';
import { TransactionStateProgressBarComponent } from '../../components/transaction-state-progress-bar/transaction-state-progress-bar.component';
import { MatInput } from '@angular/material/input';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'importer-republish-summary',
  templateUrl: './republish_summary.component.html',
  styleUrls: ['./republish_summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubHeaderComponent, ButtonFooterComponent, TransactionStateProgressBarComponent, MatInput, DatePipe]
})
export class RepublishSummaryComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly republishService = inject(RepublishService);
  private readonly router = inject(Router);

  public data: BaseRepublishDto;
  public isLoading: boolean;
  private readonly destroyRef = inject(DestroyRef);

  // eslint-disable-next-line no-restricted-syntax
  ngOnInit(): void {
    this.isLoading = true;
    this.route.params
      .pipe(
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(params => this.republishService.getSingleImportLog(params.id)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(obj => {
        this.data = obj;
        this.isLoading = false;
      });
  }

  formatErrorMessage(input: string | undefined): string {
    if (!input || typeof input !== 'string') return '';
    return input.split('jobRunId')[0].trim();
  }

  goBack() {
    this.router.navigate(['/republish']);
  }

  getLogId(text: string): string {
    return JSON.parse(text)['LOG_ID'];
  }

  openLog(id: string): void {
    this.router.navigate(['summary', id]);
  }
}
